import { render, staticRenderFns } from "./GiroPayQr.vue?vue&type=template&id=59bbd6e6"
import script from "./GiroPayQr.vue?vue&type=script&lang=js"
export * from "./GiroPayQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports